import { createContext, JSX, useReducer } from "react";
import { NetworkIntegrityFilterActions, networkIntegrityFilterInitialState, networkIntegrityFilterReducer } from "./networkIntegrityFilterStateManagement";

export interface NetworkIntegrityFilterContextProps {
  providerType: string;
  providerTypeChanged: React.Dispatch<NetworkIntegrityFilterActions>;
}

export const NetworkIntegrityFilterContext = createContext<Partial<NetworkIntegrityFilterContextProps>>({});

export const NetworkIntegrityFilterProvider = ({ children }: { children: React.ReactNode }): JSX.Element => {
  const [state, providerTypeChanged] = useReducer(networkIntegrityFilterReducer, networkIntegrityFilterInitialState);

  return (
    <NetworkIntegrityFilterContext.Provider
      value={{
        providerType: state.providerType,
        providerTypeChanged,
      }}
    >
      {children}
    </NetworkIntegrityFilterContext.Provider>
  );
}